<template>
  <div class="accidentRescueAdd">
    <div class="title">事故救援</div>
    <div class="center">
      <div class="cell">
        <van-field
          class="textarea-box"
          @keyup.enter.native="parseInfo"
          v-model="sourceText"
          rows="3"
          autosize
          type="textarea"
          placeholder="文本识别：粘贴客户信息自动识别"
        />
        <div
          class="button--parse"
          :class="{ disabled: !sourceText }"
          @click="parseInfo"
        >
          识别
        </div>
      </div>
      <van-form
        ref="form"
        label-align="right"
        label-width="5em"
        validate-first
        :show-error-message="false"
      >
        <div class="cell">
          <van-field
            v-model="formData.carNo"
            required
            name="carNo"
            label="车牌号码"
            placeholder="请输入"
            :disabled="formData.carNoChecked"
            :rules="rules.carNo"
          >
            <template #button>
              <van-checkbox
                shape="square"
                icon-size="15px"
                v-model="formData.carNoChecked"
                @click="checkChange('carNo')"
              >无</van-checkbox>
            </template>
          </van-field>
          <van-field
            v-model="formData.vinNo"
            required
            :rules="rules.vinNo"
            :maxlength="17"
            name="vinNo"
            :disabled="formData.vinNoChecked"
            label="车架号码"
            placeholder="请输入车架号"
          >
            <template #button>
              <van-checkbox
                shape="square"
                icon-size="15px"
                v-model="formData.vinNoChecked"
                @click="checkChange('vinNo')"
              >无</van-checkbox>
            </template>
          </van-field>

          <van-field
            v-model="formData.contactName"
            required
            name="contactName"
            :maxlength="10"
            label="联系人员"
            placeholder="请输入联系人姓名"
            :rules="rules.contactName"
          />

          <van-field
            v-model="formData.contactPhone"
            required
            name="contactPhone"
            :maxlength="11"
            label="联系电话"
            placeholder="请输入联系人电话"
            :rules="rules.contactPhone"
          />
        </div>
        <div class="cell">
          <van-field
            v-model="formData.contactAddress"
            required
            readonly
            clickable
            rows="1"
            autosize
            type="textarea"
            name="contactAddress"
            label="服务地址"
            placeholder="请选择"
            :rules="rules.contactAddress"
            @click="location('start')"
          >
            <template #button>
              <img
                class="img"
                src="@/assets/img/position.png"
                alt=""
              >
            </template>
          </van-field>
          <van-field
            v-model="formData.destination"
            readonly
            clickable
            name="destination"
            label="终点地址"
            placeholder="请选择"
            @click="location('end')"
          >
            <template #button>
              <img
                class="img"
                src="@/assets/img/position.png"
                alt=""
              >
            </template>
          </van-field>
        </div>
        <div class="cell">
          <van-field
            v-model="formData.channelInsuranceNo"
            required
            name="channelInsuranceNo"
            label="保单号码"
            placeholder="请输入"
            :disabled="formData.channelInsuranceNoChecked"
            :rules="rules.channelInsuranceNo"
          >
            <template #button>
              <van-checkbox
                shape="square"
                icon-size="15px"
                v-model="formData.channelInsuranceNoChecked"
                @click="checkChange('channelInsuranceNo')"
              >无</van-checkbox>
            </template>
          </van-field>
          <van-field
            v-model="formData.caseNo"
            name="caseNo"
            label="外部单号"
            :maxlength="50"
            placeholder="请输入"
          />
          <van-field
            v-model="formData.channelSettlementNo"
            name="channelSettlementNo"
            label="结算单号"
            :maxlength="50"
            placeholder="请输入"
          />
        </div>
        <div class="cell">
          <van-field
            v-model="formData.rightName"
            required
            readonly
            clickable
            name="rightName"
            label="选择权益"
            placeholder="请选择"
            :disabled="isDisabled"
            :rules="rules.rightName"
            @click="openRight"
          >
            <!-- <template #input>
              <div class="rights">请选择权益/选择后显示权益名称</div>
            </template> -->
          </van-field>

          <van-field
            label="订单备注"
            v-model="formData.orderRemark"
            autosize
            type="textarea"
            :maxlength="500"
            placeholder="请输入"
          />
        </div>

        <div class="bottom">
          <van-button
            class="submit"
            type="info"
            @click="handleSubmit"
          >确认</van-button>
        </div>
      </van-form>
    </div>
    <!-- 权益 -->
    <right-selector
      :right-options="rightList"
      ref="rightSelector"
      :disabled="rightDisable"
      @check="checkRight"
      @submit="submitRight"
    />
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import RightSelector from './components/right-selector.vue';
import { getFindValidRight, ordeCreate } from '@/common/api.js';
import { cookieGet } from '@/common/cookie';
import { Toast } from 'vant';
import { REGEX_LPN, REGEX_PHONE } from '@/common/regex.js';
import { throttle } from 'lodash';
import {
  parseOrderInfo
} from './utils/parse-order-info';
function initFormData() {
  console.log('channelCompanyCode: ', cookieGet('channelCompanyCode'));
  return {
    'channelCompanyId': cookieGet('channelCompanyCode'),
    'carNoChecked': false, 'carNo': '', 'channelInsuranceNo': '', 'vinNo': '', 'contactName': '', 'contactPhone': '', 'contactAddress': '', 'longitude': null, 'latitude': null, 'area': '', 'city': '', 'province': '', 'destination': '', 'destLongitude': null, 'destLatitude': null, 'rightName': '', 'orderRemark': '', 'channelSettlementNo': '', 'caseNo': '', 'vinNoChecked': false, 'channelInsuranceNoChecked': false
  };
}
export default {
  data() {
    const vinNoValidator = (value) => {
      if (this.formData.vinNoChecked) {
        return true;
      } else if (!this.formData.vinNoChecked && value.length === 17) {
        return true;
      } else {
        return false;
      }
    };
    const carNoValidator = (value) => {
      if (this.formData.carNoChecked) {
        return true;
      } else if (!this.formData.carNoChecked && REGEX_LPN.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    const channelInsuranceNoValidator = (value) => {
      if (this.formData.channelInsuranceNoChecked) {
        return true;
      } else if (!this.formData.channelInsuranceNoChecked && value) {
        return true;
      } else {
        return false;
      }
    };
    return {
      formData: {
        ...initFormData()
      },
      rules: {
        contactPhone: [
          // { validator: carNoValidator, message: '不能为空' }
          { required: true, message: '联系电话不能为空' },
          { pattern: REGEX_PHONE, message: '请输入正确的手机号' }
        ],
        // 联系人
        contactName: [
          { required: true, message: '联系人不能为空' },
          { pattern: /^[\u4e00-\u9fa5]{1,10}$/, message: '联系人仅支持中文' }
        ],
        // 车牌
        carNo: [
          { validator: carNoValidator, message: '不能为空' }
          // { required: true, message: '车牌号码不能为空' },
          // { pattern: REGEX_LPN, message: '请输入正确的车牌号' }
        ],
        // 服务地址
        contactAddress: [
          { required: true, message: '服务地址不能为空' }
        ],
        // 权益
        rightName: [
          { required: true, message: '权益不能为空' }
        ],
        vinNo: [
          { validator: vinNoValidator, message: '不能为空' }
        ],
        channelInsuranceNo: [
          { validator: channelInsuranceNoValidator, message: '不能为空' }
        ]
      },
      checked: false,
      // 权益列表
      rightList: [],
      // 已选择的权益
      selectedRight: {
        discount: undefined
      },
      sourceText: ''
    };
  },
  components: {
    RightSelector
  },
  computed: {
    ...mapState(['accidentRescueInfo']),
    rightDisable() {
      return !(this.rightList && this.rightList.length > 0);
    },
    isDisabled() {
      // this.formData.contactName && this.formData.contactPhone;
      return false;
    }
  },
  watch: {
    'formData.contactPhone'() {
      if (!this.rightList.length) {
        this.getFindValidRight();
      }
    }
  },
  mounted() {
    if (this.accidentRescueInfo) {
      this.formData = this.accidentRescueInfo;
    }
  },
  methods: {
    ...mapMutations([
      'setAccidentRescueInfo'
    ]),
    async parseInfo() {
      if (!this.sourceText) return;
      const text = this.sourceText;
      // 识别前需先清空原数据
      // this.sourceText = '';
      const result = await parseOrderInfo(text);
      // 根据识别结果修改数据
      this.formData = {
        ...this.formData,
        ...result
      };
      this.formData.orderRemark = text;

      // 若识别结果中有地址，需要获取对应坐标
      if (result.contactAddress) {
        this.placeSearch(result.contactAddress);
      }

      this.getFindValidRight();
    },
    // 根据地址获取经纬度
    placeSearch(val) {
      AMap.service(['AMap.PlaceSearch'], () => {
        const placeSearch = new AMap.PlaceSearch({
          city: '全国',
          extensions: 'all',
          pageSize: 10,
          pageIndex: 1
        });

        placeSearch.search(val, (status, result) => {
          console.log(result, 'result');
          if (status === 'complete' && result.poiList.pois.length > 0) {
            this.formData.longitude = result.poiList.pois[0].location.lng;
            this.formData.latitude = result.poiList.pois[0].location.lat;
          } else if (status === 'no_data') {
            this.formData.contactAddress = '';
            this.formData.longitude = null;
            this.formData.latitude = null;
            this.$toast('没有查询到对应的地址');
          }
        });
      });
    },
    handleSubmit: throttle(async function() {
      this.$toast.loading({
        message: '提交中',
        forbidClick: true,
        duration: 0
      });
      try {
        await this.$refs.form.validate();
        this.formData.productCode = this.$route.query.productCode;
        this.formData.productSkuCode = this.$route.query.skuCode;
        const res = await ordeCreate(this.formData);
        if (res) {
          Toast('下单成功');
          this.setAccidentRescueInfo(null);
          this.$router.go(-2);
        }
        this.$toast.clear();
      } catch (error) {
        console.log(error);
        this.$toast.clear();
      }
    }, 5000),
    location(type) {
      this.$router.push({
        path: '/accidentRescue/map',
        query: {
          type: type
        }
      });
      this.setAccidentRescueInfo(this.formData);
    },
    openRight() {
      this.$refs.rightSelector.openDialog();
      this.getFindValidRight();
    },
    checkRight(data) {
      this.rightList && this.rightList.forEach(item => {
        item.isCheck = false;
        if (item.rightCode === data.rightCode && item.rightRuleCode && data.rightRuleCode) {
          item.isCheck = true;
        }
      });
    },
    submitRight(list) {
      this.$nextTick(() => {
        const item = list[0];
        this.$set(this.formData, 'rightName', item.rightName);
        // this.formData.rightName = item.rightName;
        this.formData.rightCode = item.rightCode;
        this.formData.rightRuleCode = item.rightRuleCode;
        this.$refs.rightSelector.handleCancel();
      });
    },
    async getFindValidRight() {
      this.$toast.loading({
        message: '加载中',
        forbidClick: true,
        duration: 0
      });
      try {
        const res = await getFindValidRight({
          channelCompanyCode: cookieGet('channelCompanyCode'),
          phone: this.formData.contactPhone,
          areaCode: this.formData.area,
          productCode: this.$route.query.productCode,
          skuCode: this.$route.query.skuCode,
          carNo: this.formData.carNo,
          vinNo: this.formData.vinNo
        });
        if (res) {
          res.pondRightList && res.pondRightList.forEach(item => {
            this.$set(item, 'isCheck', false);
          });
          this.rightList = [...res.pondRightList];
          // 默认选择第一个权益
          if (this.rightList.length) {
            const item = this.rightList[0];
            this.formData.rightName = item.rightName;
            this.formData.rightCode = item.rightCode;
            this.formData.rightRuleCode = item.rightRuleCode;
          }
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
        this.$toast.clear();
      }
    },
    checkChange(type) {
      if (type === 'carNo' && this.formData.carNoChecked) {
        this.formData.carNo = '';
      } else if (type === 'vinNo' && this.formData.vinNoChecked) {
        this.formData.vinNo = '';
      } else if (type === 'channelInsuranceNo' && this.formData.channelInsuranceNoChecked) {
        this.formData.channelInsuranceNo = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.accidentRescueAdd{
  // padding: 0.30rem 4vw;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;

  background: #F2F3F5;

  font-size: 0.32rem;
  .title{
    position: fixed;
    z-index: 1;
    top: 0;

    width: 100vw;
    height: 1rem;

    text-align: center;
    // margin-bottom: 0.3rem;

    color: #383838;
    background: #FFFFFF;
    box-shadow: 0 0 0.08rem 0 rgba(0,0,0,0.2);

    font-weight: 500;
    line-height: 1rem;
  }
  .center{
    overflow-y: scroll;

    height: calc(100vh - 2.6rem);
    // margin-top: 1rem;
    padding-top: 1.3rem;

    .textarea-box,
    ::v-deep .textarea-box{
      padding: 12px;

      letter-spacing: -0.38px;

      border: 1px solid rgba(200,200,200,1);
      border-radius: 8px;
      background: #FFFFFF;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      ::v-deep .van-field__control{
        color: #383838;

        &::placeholder{
          color: #C8C8C8;
        }
      }
    }

    .button--parse {
      height: 32px;
      width: 72px;
      font-size: 14px;
      border-radius: 4px;
      cursor: pointer;
      background: #009eff;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 8px 0 0;
      margin-left: auto;

      &.disabled {
        cursor: not-allowed;
        background: #d2d9dc;
        color: #b3b3b3;
      }
    }
  }
  .cell{
    box-sizing: border-box;
    width: 94vw;
    margin: 0 auto 0.3rem;
    padding: 0.3rem 0.2rem;

    border-radius: 0.2rem;
    background: #fff;

    font-size: 0.3rem;
    .img{
      width: 0.35rem;
    }
  }
  .rights{
    color: #3399FF;
  }
  .bottom{
    position: fixed;
    bottom: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100vw;
    height: 1.2rem;

    background: #fff;
    box-shadow: 0 0 0.08rem 0 rgba(0,0,0,0.2);
    .submit{
      width: 90vw;
      height: 0.8rem;

      border-radius: 0.15rem;
    }
  }
}
</style>
